import React from 'react';
import { PageTransition } from '../components/PageTransition';
export function TermsOfServicePage() {
  return <PageTransition data-id="element-777">
      <div className="pt-32 pb-24 min-h-screen bg-dark-700" data-id="element-778">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-779">
          <div className="mb-12" data-id="element-780">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-781">
              Terms of Service
            </h1>
            <div className="w-24 h-1 bg-gold-500 rounded-full mb-6" data-id="element-782"></div>
            <p className="text-white/60" data-id="element-783">Last updated: March 2026</p>
          </div>

          <div className="prose prose-invert prose-gold max-w-none space-y-8 text-white/80" data-id="element-784">
            <section data-id="element-785">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-786">
                1. Acceptance of Terms
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-787">
                By accessing and using the 3 Doves Podcast website and its
                associated services, you agree to be bound by these Terms of
                Service. If you do not agree with any part of these terms,
                please do not use our website or services.
              </p>
            </section>

            <section data-id="element-788">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-789">
                2. Use of Content
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-790">
                All content provided on the 3 Doves Podcast website, including
                audio episodes, text, graphics, logos, and images, is the
                property of 3 Doves Podcast or its content creators and is
                protected by copyright laws.
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-791">
                <li data-id="element-792">
                  You may listen to, download, and share our podcast episodes
                  for personal, non-commercial use.
                </li>
                <li data-id="element-793">
                  You may not modify, reproduce, or distribute our content for
                  commercial purposes without explicit written permission.
                </li>
                <li data-id="element-794">
                  When sharing our content, proper attribution to 3 Doves
                  Podcast must be provided.
                </li>
              </ul>
            </section>

            <section data-id="element-795">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-796">
                3. User Conduct
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-797">
                We strive to build a community based on honest faith and mutual
                respect. When interacting with our website, social media
                channels, or community features, you agree to:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-798">
                <li data-id="element-799">
                  Communicate respectfully and refrain from using abusive,
                  harassing, or discriminatory language.
                </li>
                <li data-id="element-800">
                  Not post spam, promotional material, or malicious links.
                </li>
                <li data-id="element-801">
                  Respect the privacy and stories of our guests and other
                  community members.
                </li>
              </ul>
            </section>

            <section data-id="element-802">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-803">
                4. Donations and Support
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-804">
                Any donations made to 3 Doves Podcast or our associated outreach
                programs are voluntary. We are committed to using all
                contributions responsibly to further our mission and support
                those in need. All donation transactions are processed securely
                through trusted third-party providers.
              </p>
            </section>

            <section data-id="element-805">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-806">
                5. Disclaimer of Warranties
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-807">
                The content provided by 3 Doves Podcast is for informational,
                spiritual, and entertainment purposes. While we share real
                stories of faith and transformation, our content should not be
                considered a substitute for professional mental health, medical,
                or legal advice. We make no warranties regarding the accuracy or
                completeness of the information shared.
              </p>
            </section>

            <section data-id="element-808">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-809">
                6. Changes to Terms
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-810">
                We reserve the right to modify these Terms of Service at any
                time. Any changes will be effective immediately upon posting to
                this page. Your continued use of the website following the
                posting of changes constitutes your acceptance of those changes.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageTransition>;
}